<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="公司名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请选择公司名称" v-model="queryParam.supplierName"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input placeholder="请输入编码" v-model="queryParam.supplierCode"></a-input>
                  </a-form-item>
                </a-col>

              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset(2)">重置</a-button>

                </a-col>
              </span>

            </a-row>

          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <!-- 操作按钮区域 -->
      <div class="table-operator" style="margin-top: 5px">
        <!-- <a-button type="primary" @click="searchQuery">查询</a-button> -->
        <a-button @click="handleAdd" type="primary" icon="plus">添加</a-button>
        <a-button @click="shouyingDownloadTemplate('首营客户模板下载')" type="primary" icon="plus">模板下载</a-button>
        <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader"
                  :data="setFileData" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="plus">导入EXCEL</a-button>
        </a-upload>
      </div>
        <!-- table区域-begin -->
        <div>
          <a-table ref="table" size="middle" bordered :rowKey="(record,index)=>{return index}"
            :columns="columns" :dataSource="dataSource" :components="handleDrag(columns)"
            :pagination="ipagination" :loading="loading"
            :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth:'50px'}"
            @change="handleTableChange" style="word-break: break-all;">
            <span slot="action" slot-scope="text, record">
              <!-- <a-popconfirm title="是否通过审批?" ok-text="通过" cancel-text="不通过" @confirm="() => handleAudit(record,1)" @cancel="() => handleAuditCancel(record,2)">
                <a v-if="record.state === 1 || record.state === 2 || record.state === 3" disabled type="primary">审批</a>
                <a v-else type="primary">审批</a>
              </a-popconfirm> -->
              <!-- <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                <a type="primary">删除</a>
              </a-popconfirm> -->
              <a type="primary" @click="handleEdit(record)">编辑</a>
                <a-divider type="vertical" />
              <a type="primary" @click="addLicense(record)">企业证照</a>
              <a-divider type="vertical" />
              <a type="primary" @click="supplierApproval(record)" :disabled="record.state == 1 || record.state == 2 || record.state == 3">审批</a>
              <a-divider type="vertical" />
              <a type="primary" @click="getDetail(record)">详情</a>
              <!-- <a-divider type="vertical" />
              <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record)">
                <a type="primary">删除</a>
              </a-popconfirm> -->
            </span>
            <template slot="createTime" slot-scope="createTime">
              <span>{{changetime(createTime)}}</span>
            </template>
            <template slot="state" slot-scope="state">
              <a-tag v-if="state === 0" color="orange">待审核</a-tag>
              <a-tag v-else-if="state === 1" color="blue">审核中</a-tag>
              <a-tag v-else-if="state === 2" color="green">审核通过</a-tag>
              <a-tag v-else-if="state === 3" color="red">未通过</a-tag>
            </template>

          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <addModel ref="modalForm" @ok="modalFormOk" @close="modalFormClose" :productType="1"></addModel>
        <manufactureLicenseList ref="manufactureLicenseList" @ok="modalFormOk" @close="modalFormClose"></manufactureLicenseList>
        <EnterpriseDetail ref="modalDetail" @ok="modalDetailOk" @close="modalDetailClose"></EnterpriseDetail>
      </a-card>
    </a-col>
  </a-row>
</template>
<!-- create ji sheng hua-->
<script>
//ledgerAdd EnterpriseDetail
import addModel from '../modules/addModel'
import manufactureLicenseList from '../modules/manufactureLicenseList'
import EnterpriseDetail from '../modules/enterpriseDetail'
import { campListMixins } from '../mixins/campListMixins'
import { ledgerDelete,ledgerEdit, companyDetail, supplyDelete, supplyApproval } from '@/api/api'
import JDate from '@/components/jeecg/JDate'


export default {
  name: '客户管理',
  mixins: [campListMixins],
  components: {
    manufactureLicenseList,
    EnterpriseDetail,
    addModel,
    JDate,
  },
  data() {
    return {
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '100', '200'],
      },
      // 查询条件
      queryParam: {
        type: '经销商',
      },
      prefixNo: 'LSCK',
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      setFileData:{
        type:1
      },
      // 默认列
      columns: [
        { title: '序号', dataIndex: 'index', width: 50, customRender:(text,record,index) =>`${index + 1}`},
        { title: '企业名称', dataIndex: 'supplierName', ellipsis: true, render: (text) => text || "--" },
        { title: '编码', dataIndex: 'supplierCode',render: (text) => text || "--" },
        { title: '法定代表人', dataIndex: 'ledge',width: 150, render: (text) => text || "--"},
        { title: '统一社会信用代码', dataIndex: 'credit',  width: 250,render: (text) => text || "--" },
        { title: '注册资金', dataIndex: 'capital',render: (text) => text || "--"},
        { title: '状态', dataIndex: 'state',align: "center",scopedSlots: { customRender: 'state' } },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 280,
          // fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/sy/supplier/list',

      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${'/sy/supplier/importExcel'}`;
    }
  },
  created() {

  },
  methods: {

    changetime(createTime) {
      return createTime.replace('T', ' ')
    },
    //打开详情
    async getDetail(record){
      console.log(record,'详细信息=======================')
      let params = {
          id : record.supplierId
      }
      const res = await companyDetail(params)
      if (res.code == 200 && res.success == true) {
          console.log(res)
          this.$message.success(res.message)
          this.$refs.modalDetail.initShow(res)
      } else {
          this.$message.error(res.message)
      }
      // this.$refs.modalDetail.initShow(res)
    },
    addLicense(record){
      console.log(record,'详细信息=======================')
      this.$refs.manufactureLicenseList.initShow(record)
    },
    async handleAudit(record,e) {
      console.log(record,'审核record============')
      let params = {
        uuid : record.uuid,
        state: e
      }
      const res = await ledgerEdit(params)
      this.loadData()
    },
    //提交审批
    async supplierApproval(record){
        console.log(record,'审核record============')
        let params = {
          supplierId : record.supplierId,
        }
        const res = await supplyApproval(params)
        if(res.code == 200 && res.success == true){
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
        this.loadData()
      },
    //删除handleDelete
    async handleDelete(record) {
      let params = {
        id : record.id
      }
      const res = await supplyDelete(params)
      if (res.code == 200 && res.success == true) {
        this.$message.success(res.message)
        this.loadData()
      } else {
        this.$message.error(res.message)
      }

    },
    modalFormOk(){
      console.log('1')
      this.loadData()
    },
    modalFormClose(){
      console.log('1')
      this.loadData()
    },
    modalLicenseOk(){
      console.log('1')
      this.loadData()
    },
    modalLicenseClose(){
      console.log('1')
      this.loadData()
    },
    modalDetailOk(){
      console.log('1')
      this.loadData()
    },
    modalDetailClose(){
      console.log('1')
      this.loadData()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
/deep/.ant-table-row-cell-break-word:empty:after {
  content: '--';
}
</style>